var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.signup)?_c('LoginStudioForm',{on:{"signup":function($event){_vm.signup=true}}}):_vm._e(),(_vm.signup)?_c('SignupStudio',{on:{"login":function($event){_vm.signup=false}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }